import { Payment } from '@material-ui/icons';
import PaymentList from './PaymentList';

export default {
    list: PaymentList,
    icon: Payment,
};
